// src/utils/preferenzeDispositivo.js
// ═══════════════════════════════════════════════════════════════════════════
// PREFERENZE DI QUESTO DISPOSITIVO (ottobre 2026)
// ═══════════════════════════════════════════════════════════════════════════
// Scelte che valgono per il telefono (o il computer) che si sta usando, non per l'account:
// stanno nel browser e non nel database. Si cambiano in Impostazioni → Profilo.
//  • TESTO PIÙ GRANDE (telefoni e tablet): per chi lavora in cantiere con i guanti, al sole
//    o vede meno bene. Il telefono disegna Nexiora come su uno schermo un po' più stretto e
//    lo allarga a tutto schermo: scritte, pulsanti e campi crescono insieme, nelle stesse
//    proporzioni (nessuna pagina si deforma). Sul computer c'è già Ctrl e + del browser.
//  • VIBRAZIONE DI CONFERMA (telefoni Android): un colpetto quando un'operazione va a buon
//    fine (salvataggio, timbratura, firma), due brevi se qualcosa non è andato. iPhone non
//    permette alle pagine web di vibrare: lì semplicemente non succede nulla.
// Tutto protetto: se il browser non consente di ricordare le scelte, resta come prima.
// ═══════════════════════════════════════════════════════════════════════════

const K_TESTO = "nexiora_testo";
const K_VIBRA = "nexiora_vibrazione";

const leggi = (k) => { try { return localStorage.getItem(k); } catch { return null; } };
const scrivi = (k, v) => { try { localStorage.setItem(k, v); } catch { /* non disponibile */ } };

export const DIMENSIONI_TESTO = [
  { id: "normale", etichetta: "Normale", scala: 1 },
  { id: "grande", etichetta: "Grande", scala: 1.15 },
  { id: "molto", etichetta: "Molto grande", scala: 1.3 },
];

/** È un telefono o un tablet (schermo touch)? Lì vale il testo più grande. */
export const eDispositivoTouch = () => {
  try { return !!window.matchMedia?.("(pointer: coarse)").matches; } catch { return false; }
};

export function dimensioneTesto() {
  const v = leggi(K_TESTO);
  return DIMENSIONI_TESTO.some(d => d.id === v) ? v : "normale";
}

let ascoltoRotazione = false;
/** Applica la dimensione del testo scelta (solo sui dispositivi touch). */
export function applicaDimensioneTesto() {
  try {
    const meta = document.querySelector('meta[name="viewport"]');
    if (!meta) return;
    const scala = (DIMENSIONI_TESTO.find(d => d.id === dimensioneTesto()) || DIMENSIONI_TESTO[0]).scala;
    if (scala === 1 || !eDispositivoTouch()) {
      meta.setAttribute("content", "width=device-width, initial-scale=1");
    } else {
      // larghezza dello schermo nell'orientamento attuale, divisa per la scala
      const orizzontale = window.matchMedia?.("(orientation: landscape)").matches;
      const lati = [window.screen?.width || window.innerWidth, window.screen?.height || window.innerHeight];
      const larghezza = orizzontale ? Math.max(...lati) : Math.min(...lati);
      meta.setAttribute("content", `width=${Math.round(larghezza / scala)}`);
    }
    if (!ascoltoRotazione) {
      ascoltoRotazione = true;
      window.addEventListener("orientationchange", () => setTimeout(applicaDimensioneTesto, 150));
    }
  } catch { /* si resta come prima */ }
}

export function impostaDimensioneTesto(id) {
  scrivi(K_TESTO, id);
  applicaDimensioneTesto();
}

export const vibrazioneAttiva = () => leggi(K_VIBRA) !== "no";
export const impostaVibrazione = (attiva) => scrivi(K_VIBRA, attiva ? "si" : "no");
export const vibrazioneSupportata = () => typeof navigator !== "undefined" && typeof navigator.vibrate === "function";

/** Vibrazione di conferma: "ok" (un colpetto) o "errore" (due brevi). */
export function vibra(tipo = "ok") {
  try {
    if (!vibrazioneAttiva() || !vibrazioneSupportata()) return;
    navigator.vibrate(tipo === "errore" ? [40, 70, 40] : 30);
  } catch { /* niente */ }
}
